import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { addArticleCash, fetchArticlesCashCategories, setAddArticleCash } from '../../action/handbook';
import cn from 'classnames';
import ErrorContainer from '../utils/ErrorContainer';
import Select from 'react-select';
import { optionsMovementCash, optionsTransaction } from '../../constants/app';

class AddArticleCash extends Component {
    componentWillUnmount() {
        this.props.setAddArticleCash({});
    }

    componentDidMount() {
        this.props.fetchArticlesCashCategories();
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Добавить кассовую статью</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/articlesCash')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidArticleCash() {
        const { name, typeTransaction, typeMovementCash, category } = this.props.addForm;
        if (name && typeTransaction && typeMovementCash && category) return true;
        return false;
    }

    setArticleCash = (field) => (e) => {
        const data = {...this.props.addForm};
        if(field === 'name') {
            data[field] = e.target.value;
        } else {
            data[field] = e.value;
        }

        // if(field === 'typeMovementCash' && e.value === 'incasso') {
        //     data.typeTransaction = 'cash';
        // }

        this.props.setAddArticleCash(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addArticleCash(this.props.addForm).then(result => {
            if (result) {
                this.props.history.push('/handbook/articlesCash');
            }
        });
    }

    getCategoryValue = () => {
        const categortId = this.props.addForm.category ? this.props.addForm.category.id ? this.props.addForm.category.id : this.props.addForm.category : null;
        if (!categortId) return null;
        const entity = this.props.articlesCashCategories.find((item) => item.id === categortId);
        if (!entity) return null;
        return { value: entity.id, label: entity.name };
    }

    render() {
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">  
                            <div className="row">
                                <div className="col-md-4">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setArticleCash('name')}
                                        value={this.props.addForm.name}
                                        placeholder="Название..."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>{"Тип транзакции *"}</label>
                                    <Select
                                        isDisabled={this.props.addForm.typeMovementCash === 'incasso'}
                                        closeMenuOnSelect={true}
                                        value={optionsTransaction.find((option) => option.value === this.props.addForm.typeTransaction)}
                                        onChange={this.setArticleCash('typeTransaction')}
                                        placeholder="Тип транзакции"
                                        options={optionsTransaction}
                                        noOptionsMessage={() => 'Нет типов'}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>{"Тип *"}</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={optionsMovementCash.find((option) => option.value === this.props.addForm.typeMovementCash)}
                                        onChange={this.setArticleCash('typeMovementCash')}
                                        placeholder="Тип"
                                        options={optionsMovementCash.filter((option) => !option.notRender)}
                                        noOptionsMessage={() => 'Нет типов'}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label>{"Категория *"}</label>
                                    <Select
                                        isLoading={this.props.loading}
                                        closeMenuOnSelect={true}
                                        value={this.getCategoryValue()}
                                        onChange={this.setArticleCash('category')}
                                        placeholder="Категория"
                                        options={this.props.articlesCashCategories.map((item) => ({ value: item.id, label: item.name}))}
                                        noOptionsMessage={() => 'Нет категорий'}
                                    />
                                </div>
                            </div>
                        </div>
                        <ErrorContainer field="addArticleCash" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidArticleCash() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Добавить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    articlesCashCategories: state.handbook.articlesCashCategories,
    addForm: state.handbook.add,
    loading: state.loaders.addArticleCash || state.loaders.articlesCashCategories,
});

const mapDispatchToProps = {
    setAddArticleCash: (data) => setAddArticleCash(data),
    fetchArticlesCashCategories: () => fetchArticlesCashCategories(true),
    addArticleCash: (data) => addArticleCash(data)
}

export default connect(mapStateToProps, mapDispatchToProps)(AddArticleCash);